module.exports = __webpack_public_path__ + "static/media/logo_menor_fundo_escuro .397f538b.png";